import {
  Flex,
  Tooltip,
} from "@components/index";

import { useDetailsGanttContext } from "@src/pages/Dashboard/contexts/DetailsGantt.context";
import { useStatusGantt } from "@src/common/hooks/useStatusGantt";
import styles from "./TimelineCard.module.scss";
import TimesGanttFragment from "@src/common/fragments/TimesGantt.fragment";
import { Icons } from "../../Icons";

interface TimelineCardProps {
  leftPx: number;
  widthPx: number;
  event: Sentinel.Timeline.Event;
  isExiting?: boolean;
}

const TimelineCard: React.FC<TimelineCardProps> = ({
  leftPx,
  widthPx,
  event,
  isExiting = false,
}) => {
  const { onOpen } = useDetailsGanttContext();
  const { variant } = useStatusGantt(event?.status);
 
  const generateVariantClassName = (
    cssModule: Record<string, string>,
    baseClass: string,
    variant: string,
    additionalClass?: string
  ): string => {
    const variantClass = `${baseClass}-${variant}`;
    let className = `${cssModule[baseClass]} ${cssModule[variantClass]}`;
    
    if (additionalClass) {
      className += ` ${additionalClass}`;
    }
    
    return className;
  };

  const exitingClass = isExiting ? styles.exiting : undefined;
  const classNameContainer = generateVariantClassName(
    styles,
    "card-container",
    variant,
    exitingClass
  );

  const classNameContent = generateVariantClassName(
    styles,
    "card-content",
    variant
  );

  return (
    <div
      className={classNameContainer}
      style={{ left: `${leftPx}px`, width: `${widthPx}px` }}
    >
      <Flex.Col
        className={classNameContent}
        onClick={() => onOpen(event)}
      >
        <div className={styles["card-content-padding"]}>
          <Tooltip position="top" description={event.displayName}>
            <Flex.Col gap="3px">
              <div className={styles["card-content-description"]}>
                {event.displayName}
              </div>
              <TimesGanttFragment event={event} gapRow="4px" />
            </Flex.Col>
          </Tooltip>
        </div>

        {event.isCritical && (
          <div className={styles["card-content-critico"]}>
            <Icons name="bookmark-fill" />
          </div>
        )}
      </Flex.Col>
    </div>
  );
};

export default TimelineCard;
